import { translate } from '@/locales/route'

const errorCodeKeys: Record<string, string> = {
  '401': 'request.errors.401',
  '403': 'request.errors.403',
  '404': 'request.errors.404',
  default: 'request.errors.default',
}

export default new Proxy(errorCodeKeys, {
  get(target, key: string) {
    return translate(target[key] || target.default)
  },
})
